module.exports = __webpack_public_path__ + "static/media/daji.a64c58bf.png";